import styled from 'styled-components';
import LocationOnIcon from '@mui/icons-material/LocationOn';

export const LocationIcon = styled(LocationOnIcon)`
  color: green;
`;
